type AppConfig = {
  elevateUrl: string;
  oauthUrl: string;
  oauthAppId: string;
  hostUrl: string;
  sageMarketingUrl: string;
  isProduction: boolean;
};

const localConfig: AppConfig = {
  elevateUrl: "https://elevate.talis.local/",
  oauthUrl: "https://persona.talis.local/",
  oauthAppId: "catalyst-local-app",
  hostUrl: `${document.location.origin}/`,
  sageMarketingUrl: `${document.location.origin}/talis`,
  isProduction: false,
};

const productionConfig: AppConfig = {
  elevateUrl: "https://app.talis.com/",
  oauthUrl: "https://users.talis.com/",
  oauthAppId: "catalyst-prod-app",
  hostUrl: "https://catalyst.talis.com/",
  sageMarketingUrl: "https://uk.sagepub.com/en-gb/eur/sage-catalyst-book-list",
  isProduction: true,
};

const stagingConfig: AppConfig = {
  elevateUrl: "https://app.talis.com/",
  oauthUrl: "https://users.talis.com/",
  oauthAppId: "catalyst-staging-app",
  hostUrl: `${document.location.origin}/`,
  sageMarketingUrl: "https://uk.sagepub.com/en-gb/eur/sage-catalyst-book-list",
  isProduction: false,
};

const testConfig = {
  elevateUrl: "https://elevate.talis.local/",
  oauthUrl: "https://users.talis.com/",
  oauthAppId: "catalyst-test-app",
  hostUrl: "https://catalyst.talis.local:3005/",
  sageMarketingUrl: "http://testing.example.com",
  isProduction: false,
};

let config = localConfig;

if (
  `${document.location.origin}/` === productionConfig.hostUrl ||
  document.location.origin.includes("production")
) {
  config = productionConfig;
} else if (document.location.origin.includes("staging")) {
  config = stagingConfig;
} else if (process.env.REACT_APP_ENV === "test") {
  config = testConfig;
}

export default config;
